module.exports = __webpack_public_path__ + "img/clue05.7fe32374.png";